import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let BulkDeleteComponent = {
    selector: "vcBulkDelete",
    templateUrl: "/angular/components/people/bulk-delete.component.html",
    bindings: {
        numItems: "=",
        itemType: "=",
        anonymize: "=",
    },
    controller: class BulkDeleteController {
        // * bindings for typescript compiler *
        public numItems: any;
        public itemType: any;
        public anonymize: any;
        // ************************************

        private confirm_text = "";
        private analyticsSentence =
            "Any analytics associated with these contacts will also be deleted.";
        private itemName: string;
        private deleteString: string;
        private sentence: string;

        private dialog: DialogUtils;
        private $filter: any;
        private __env: any;

        constructor(DialogUtils: DialogUtils, $filter: any, __env: any) {
            this.dialog = DialogUtils;
            this.$filter = $filter;
            this.__env = __env;
        }

        $onInit() {
            this.itemName =
                this.numItems > 1 ? this.itemType + "s" : this.itemType;
            this.deleteString = this.anonymize ? "anonymize" : "delete";

            if (this.numItems === 1) {
                this.sentence = " this " + this.itemType;
            } else {
                this.sentence =
                    " these " +
                    this.$filter("number")(this.numItems) +
                    " " +
                    this.itemType +
                    "s";
            }

            if (this.anonymize) {
                this.analyticsSentence =
                    "Only the analytics from these contacts will be retained.";
            }
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("people")
    .component(BulkDeleteComponent.selector, BulkDeleteComponent);
